import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Button,
  Container,
  CircularProgress,
  Alert,
} from "@mui/material";
import IndexCard from "../../../shared/IndexCard";
import { Link, useLocation, useNavigate } from "react-router-dom";

const JobListPage = () => {
  const [tabIndex, setTabIndex] = useState(0); // 0: 募集中, 1: 募集終了
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // 画面遷移を検知するため
  const navigate = useNavigate();
  const flashMessage = location.state?.flashMessage; //　メッセージ受けとる

  useEffect(() => {
    setLoading(true);
    fetch("/company/jobs.json")
      .then((res) => res.json())
      .then((data) => {
        setJobs(data);
        setLoading(false);
      });
  }, [location.key]); // 戻ってくるたびに再取得される

  // 掲載期間が過ぎたら募集終了に振り分け
  const filteredJobs = jobs.filter((job) => {
    if (!job.publish_end_date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(job.publish_end_date);

    return tabIndex === 0 ? endDate >= today : endDate < today;
  });

  return (
    <>
      {/* フラッシュメッセージ*/}
      {flashMessage && (
        <Box sx={{ px: 2, py: 1 }}>
          <Alert severity="success">
            {typeof flashMessage === "object"
              ? flashMessage.message
              : flashMessage}
          </Alert>
        </Box>
      )}

      <Container maxWidth="md" sx={{ mt: 4, mb: 10 }}>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h5" fontWeight="bold">
            求人
          </Typography>
          <Button
            variant="outlined"
            onClick={() => navigate("/company/jobs/new")}
            sx={{ fontWeight: "bold" }}
          >
            ＋ 新規投稿
          </Button>
        </Box>

        <Tabs
          value={tabIndex}
          onChange={(_, v) => setTabIndex(v)}
          sx={{ mb: 2 }}
        >
          <Tab label="募集中" />
          <Tab label="募集終了" />
        </Tabs>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : filteredJobs.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            現在、投稿された求人はありません。
          </Typography>
        ) : (
          filteredJobs.map((job) => (
            <IndexCard
              key={job.id}
              item={job}
              type="job"
              component={Link}
              to={`/company/jobs/${job.id}`}
            />
          ))
        )}
      </Container>
    </>
  );
};

export default JobListPage;
